import {
  Pagination as PaginationAdminUI,
  UsePaginationReturn,
} from '@vtex/admin-ui';
import { usePagination } from './use-pagination.hook';

export type PaginationProps = {
  totalItems: number;
  itemsPerPage: number;
  onPageChange: (pagination: UsePaginationReturn) => void;
};

export const Pagination = (props: PaginationProps) => {
  const { pagination } = usePagination({ ...props });

  return <PaginationAdminUI state={pagination} />;
};
